/**
 * Textos da modal de e-mail do download do app (visitas de campanha).
 * Não cita a campanha nem o parceiro: o visitante não os conhece.
 *
 * A linha de aceite repete a fórmula que o próprio site já usa no aviso de
 * cookies ("Ao continuar navegando, você concorda com a nossa Política de
 * Privacidade") e a cláusula dos Termos de Uso ("Ao utilizar nosso website,
 * aplicativo e outras plataformas digitais [...] o usuário declara que leu,
 * entendeu e concorda"). Nenhum dos dois textos fala de e-mail nem de
 * atribuição: falta atualizar a Política antes de publicar (ver o PR).
 */
export const APP_DOWNLOAD_MODAL_COPY = {
  title: "Antes de baixar o app",
  lead: "Informe seu e-mail para continuar.",
  emailLabel: "Seu e-mail",
  emailError: "Informe um e-mail válido para continuar.",
  submitLabel: "Continuar para a loja",
  cancelLabel: "Cancelar",
  consentPrefix: "Ao continuar, você concorda com os",
  termsLabel: "Termos de Uso",
  termsUrl: "https://achados.voopter.com.br/termos",
  consentJoin: "e a",
  privacyLabel: "Política de Privacidade",
  privacyUrl: "https://achados.voopter.com.br/privacidade",
  whyLabel: "Por que pedimos o e-mail?",
  whyText:
    "Para saber que você chegou ao app por este site. Seu aparelho transforma o e-mail em um código, e só o código vai ao Google Analytics e, quando você abrir uma oferta no app, ao nosso site. O e-mail em si não é enviado nem guardado, e não mandamos mensagens para ele. O código ainda é um dado pessoal: quem tem o seu e-mail consegue gerar o mesmo.",
} as const;
